"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'You can pass content to the Card using the ' +
    '<code class="inline">title</code> property and something between the tags.';
var code = "import React from 'react';\nimport { Card } from 'jsc-react-ui';\n\nconst CardExample = () => (\n  <Card title=\"Thoughts\">\n    Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor,\n    ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum.\n  </Card>\n);";
exports.TitleAndContentExampleCard = function () { return (React.createElement(common_1.Example, { title: "Title and Content", description: description, code: code },
    React.createElement(components_1.Card, { title: "Thoughts" }, "Sed tempus, odio nec laoreet pulvinar, erat elit tristique dolor, ut sollicitudin ex nunc vel eros. Sed magna erat, condimentum."))); };
exports.TitleAndContentExampleCard.displayName = 'TitleAndContentExampleCard';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentCardPage/TitleAndContentExampleCard.tsx
// module id = 642
// module chunks = 0